import { useAuthentication } from '@app/src/context/AuthenticationContext'
import useOrganizationSettings from '@app/src/hooks/useOrganizationSettings'
import { isAdminRole } from '@app/src/utils/rolePermissions'
import { FormControlLabel, Switch } from '@mui/material'
import React from 'react'
import { useIntl } from 'react-intl'

interface OrganizationSettingSwitchProps {
  settingKey: 'aiScreeningEnabled' | 'aiCaptureWebPagesAsFiles'
  ariaLabel: string
}

const OrganizationSettingSwitch: React.FC<OrganizationSettingSwitchProps> = ({ settingKey, ariaLabel }) => {
  const { formatMessage } = useIntl()
  const { role } = useAuthentication().scope
  const { settings, updateOrganizationSettings, isSaving, isFetching } = useOrganizationSettings()
  const isOn = settings?.[settingKey] ?? false

  return (
    <FormControlLabel
      disabled={!isAdminRole(role) || isSaving || isFetching || !settings}
      control={
        <Switch
          checked={isOn}
          inputProps={{ 'aria-label': ariaLabel }}
          onChange={(_, checked) => updateOrganizationSettings({ [settingKey]: checked })}
        />
      }
      label={formatMessage({ id: `automations.${isOn ? 'on' : 'off'}` })}
      sx={{ flexShrink: 0, mr: 0 }}
    />
  )
}

export default OrganizationSettingSwitch
